import { Link, useParams } from "react-router-dom";
import Footer from "../components/home/Footer";
import NotFound from "./NotFound";
import data from "../helpers/DataHelper";
import { Box, Button, Toolbar, Typography, useTheme } from "@mui/material";
import ScrollTop from "../components/layout/ScrollTop";
import { Trans, useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";

import { Autoplay } from 'swiper/modules';
import Grid from '@mui/material/Grid2';
// Import Swiper styles
import 'swiper/css';
import ProjectsList from "../components/layout/ProjectsList";
import NftComposer from "../components/layout/NftComposer";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { initializeProjectPage, resetInitProjectPageState } from "../slices/initProjectPage";
import TechStack from "../components/home/TechStack";
import { setCurrentLinks } from "../slices/themeSlice";

export default function ProjectPage(props) {

  const { projectId } = useParams();

  const theme = useTheme();

  const { t } = useTranslation();

  const dispatch = useDispatch()

  const projectPageInitialized = useSelector(state => state.initProjectPage.projectPageInitialized)
  const currentProject = useSelector(state => state.initProjectPage.currentProject)

  useEffect(() => {
    dispatch(resetInitProjectPageState())
    if (projectId && projectId in data.projects) {
      dispatch(initializeProjectPage(projectId))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId])

  const currentLinks = [
    {
      id: "back-to-top-anchor",
      title: "label_intro",
    },
    {
      id: "link-to-scroll-description",
      title: "label_title_description",
    },
    {
      id: "link-to-scroll-gallery",
      title: "label_gallery",
    },
    {
      id: "link-to-scroll-tools",
      title: "label_tools",
    },
    {
      id: "link-to-scroll-otherprojects",
      title: "label_other_projects",
    },
  ];

  useEffect(() => {
    dispatch(setCurrentLinks(currentLinks))
  }, []);

  // console.log(projectId && projectId in data.projects)
  // console.log(projectId)
  // console.log(projectId, data.projects)
  if (projectPageInitialized) {

    return (
      <Box sx={{
        // minHeight: `calc(100svh - ${appBarHeight}px)`,
        minHeight: `calc(100svh)`,
        background: theme.palette.background.paper,
        display: "flex",
        flexDirection: "column",
      }}>
        <Toolbar id="back-to-top-anchor" />
        <>
          <Grid container>
            {/* INTRO */}
            <Grid
              size={{
                xs: 12
              }}
              sx={{
                minHeight: "100svh",
                mb: "8.33%",
                zIndex: 0,
                display: "flex",
                flaxDirection: "column",
              }}>
              <Box sx={{
                // display: "none",
                position: "absolute",
                top: 0,
                width: "100%",
                height: "100svh",
                // display: "flex",
                overflow: "hidden",
                zIndex: -1,
                video: {
                  minWidth: "100%",
                  minHeight: "100%",
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "cover",
                  position: "absolute",
                  objectPosition: "center center",
                  transform: "translate(-50%, -50%)",
                  top: "50%",
                  left: "50%",
                  zIndex: 100,
                },
                img: {
                  position: "absolute",
                  minWidth: "100%",
                  minHeight: "100%",
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "cover",
                  objectPosition: "center center",
                  transform: "translate(-50%, -50%)",
                  top: "50%",
                  left: "50%",
                  zIndex: 10,
                  ".mobile": {
                    display: "none",
                  }
                },
                [theme.breakpoints.down("md")]: {
                  ".desktop": {
                    display: "none",
                  },
                  ".mobile": {
                    display: "block",
                  }
                }
              }}>
                {
                  currentProject.video &&
                  <video
                    poster={currentProject.imgCover} autoPlay loop muted>
                    <source src={currentProject.video} type="video/mp4" />
                  </video>

                }
                <img src={currentProject.bannerVertical} className="mobile" alt={"cover of giano project " + currentProject.title} />
                <img src={currentProject.bannerHorizontal} className="desktop" alt={"cover of giano project " + currentProject.title} />
              </Box>
              <Box
              sx={{
                background: theme.palette.background.paper + "33",
                backdropFilter: "blur(40px)",
                zIndex: 10,
                // mt: `calc(calc(-8.33% - 5vw) - 40px)`,
                outline: theme.palette.divider,
                maxWidth: "90%",
                overflow: "hidden",
                userSelect: "none",
                borderRadius: "40px",
                mx: "40px",
                p: "40px 100px",
                mt: "auto",
                mb: "8.33%",
                [theme.breakpoints.down("md")]: {
                  // mt: `calc(calc(-8.33% - 15vw) - 24px)`,
                  background: theme.palette.background.paper,
                  mx: "0px",
                  p: "24px",
                  borderRadius: "24px 24px 0px 0px",
                  mb: "0",
                  maxWidth: "100%",
                },
                "& .projectTitle": {
                  fontSize: "10vw",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  lineHeight: "1",
                  [theme.breakpoints.down("md")]: {
                    fontSize: "13.5vw",
                  },
                }
              }}>
                <Typography className="projectTitle" component="h1">{t(currentProject.title)}</Typography>
              </Box>

            </Grid>
            <Grid
            id="link-to-scroll-description"
            size={{
              xs: 12,
            }}
            >

            </Grid>
            {/* IMAGE SQUARED */}
            <Grid
            size={{
              xs: 12,
              md: 3,
            }}
              offset={{
                md: 1,
                xl: 2
              }}
              sx={{
                p: 2,
              }}
            >
              <Box sx={{
                display: "flex",
                position: "sticky",
                top: "104px",
                img: {
                  width: "100%",
                  objectFit: "contain",
                  objectPosition: "center",
                  mb: "8.33%",
                  borderRadius: "40px",
                  display: "flex",
                }
              }}>
                <img src={currentProject.imgSqr} alt={"squared screenshot of giano project " + currentProject.title} />
              </Box>
            </Grid>
            {/* DESCRIPTION */}
            <Grid
            size={{
              xs: 12,
              md: 6,
              xl: 4
            }}
              offset={{
                md: 1
              }}
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                p: 2,
              }}
            >
              <Typography variant="h3" sx={{
                fontWeight: "bold",
              }}>
                <Trans
                  i18nKey={
                    currentProject.short_description}>
                </Trans>
              </Typography>
              <Typography variant="h4" textAlign="">
                <Trans
                  i18nKey={
                    currentProject.description}>
                </Trans>

              </Typography>
              <Box sx={{
                width: "100%",
              }}>

              </Box>
              <Typography variant="h6" textAlign="right">
                <i>{t(currentProject.date)}</i>
              </Typography>
            </Grid>

            {/* LINK */}
            {
              currentProject.link &&
              <Grid size={{
                xs: 12,
              }}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  minHeight: "20svh",
                  alignItems: "center",
                  p: 2,
                }}
              >
                <Link to={currentProject.link.url}
                  target={currentProject.link.target}
                  style={{
                    textAlign: "center",
                    display: "block"
                  }}>
                  <Button
                    variant="contained"
                    color="primary"
                    disableElevation
                    sx={{
                      borderRadius: "100px",
                      p: "20px 40px",
                    }}
                  >
                    <Typography
                      variant="h2"
                      sx={{
                        fontWeight: "bold",
                        textTransform: "uppercase",
                      }}
                    >{t(currentProject.link.label)}</Typography>
                  </Button>
                </Link>
              </Grid>
            }

            {/* GIF PREVIEW */}
            {currentProject.gif &&
            <Grid size={{
              xs: 12,
            }}
              sx={{
                p: "24px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                video: {
                  maxWidth: "100%",
                  borderRadius: "40px",
                }
              }}>
                <video autoPlay loop muted playsInline>
                  <source src={currentProject.gif} type="video/mp4" />
                </video>
              </Grid>
            }

            {/* SCREENSHOTS */}
            {currentProject.screenshots?.length > 0 &&
              <Grid
              id="link-to-scroll-gallery"
              size={{
                xs: 12,
              }}
                sx={{
                  p: 2,
                }}
              >
                <Typography sx={{
                  ml: "24px",
                  [theme.breakpoints.down("md")]: {
                    ml: "8px",
                    fontSize: "15vw",
                  },
                  fontSize: "10vw",
                  fontWeight: "bold",
                  lineHeight: "1.2",
                }}
                >
                  Gallery
                </Typography>
              </Grid>
            }
            {currentProject.screenshots?.length > 0 &&
              <>
                <Grid
                  size={{
                    xs: 12
                  }} offset={{ xs: 0 }}
                  sx={{
                    my: "8.33%",
                    [theme.breakpoints.down("md")]: {
                      display: "none",
                    }
                  }}>
                  <Box sx={{
                    display: "flex",
                    gap: "8.33%",
                    // border: "2px solid red",
                    img: {
                      maxWidth: "100%",
                      maxHeight: "100%",
                      display: "flex",
                      aspectRatio: "16/9",
                      objectFit: "contain",
                    },
                    "& .swiper": {
                      width: "100%",
                    },
                    "& .swiper-slide": {
                      display: "flex",
                      borderRadius: "40px",
                      overflow: "hidden",
                      [theme.breakpoints.down("md")]: {
                        borderRadius: "24px",
                      }
                    },
                    maxHeight: "90svh",
                  }}>
                    <Swiper
                      spaceBetween={30}
                      // slidesPerView={1.5}
                      breakpoints={{
                        "640": {
                          slidesPerView: 1,
                        },
                        "1024": {
                          slidesPerView: 1.5,
                        }
                      }}
                      // onSlideChange={() => console.log('slide change')}
                      // onSwiper={(swiper) => console.log(swiper)}
                      loop={true}
                      autoplay={{
                        delay: 1500,
                        disableOnInteraction: false,
                      }}

                      speed={5000}
                      modules={[Autoplay,]}
                    >
                      {
                        currentProject.screenshots?.map((img, i) => {
                          return (
                            <SwiperSlide key={i}>
                              <img src={img} alt={"screenshot of giano project " + currentProject.title + " number " + i} />
                            </SwiperSlide>
                          )
                        })
                      }
                    </Swiper>
                  </Box>
                </Grid>
                <Grid
                  size={{
                    xs: 12
                  }} offset={{ xs: 0 }}
                  sx={{
                    my: "8.33%",
                    p: 2,
                    [theme.breakpoints.up("md")]: {
                      display: "none",
                    },
                    display: "flex",
                    gap: 2,
                    flexDirection: "column",
                    img: {
                      maxWidth: "100%",
                      maxHeight: "100%",
                      display: "flex",
                      aspectRatio: "16/9",
                      objectFit: "contain",
                      borderRadius: "24px"
                    },

                  }}>
                  {
                    currentProject.screenshots?.map((img, i) => {
                      return (

                        <img src={img} key={"image" + i} alt={"screenshot of giano project " + currentProject.title + " number " + i} />

                      )
                    })
                  }
                </Grid>
              </>
            }

            {
              projectId === "nft" &&
              <Grid size={{
                xs: 12,
              }} sx={{
                p: 2,

              }}>
                <NftComposer></NftComposer>
              </Grid>



            }
          </Grid>
        </>

        {/* TOOLS */}
        {
          currentProject.tech.length > 0 &&
          <Grid
          id="link-to-scroll-tools"
          size={{
            xs: 12
          }} sx={{
            mb: "8.33%",
            p: 2,
          }}>
            <Typography sx={{
              ml: "24px",
              [theme.breakpoints.down("md")]: {
                ml: "8px",
                fontSize: "15vw",
              },
              fontSize: "10vw",
              fontWeight: "bold",
              lineHeight: "1.2",
              mb: "8.33%",
            }}
            >
              {t("tech_tools")}
            </Typography>
            <TechStack filterArray={currentProject.tech} />
          </Grid>
        }

        <Grid
        id="link-to-scroll-otherprojects"
        size={{
          xs: 12,
        }}>

          <ProjectsList projectToHide={projectId} />
        </Grid>
        <ScrollTop />
        <Footer></Footer>
      </Box>
    )
  } else {
    return <NotFound></NotFound>
  }
}
